import { useEffect } from 'react';
import Lenis from 'lenis';
import '@/index.css';
import { ErrorBoundary } from '@/components/Reveal';
import Nav from '@/components/Nav';
import Hero from '@/components/Hero';
import Marquee from '@/components/Marquee';
import Viral from '@/components/Viral';
import CarPool from '@/components/CarPool';
import GuestList from '@/components/GuestList';
import WhosNext from '@/components/WhosNext';
import Started from '@/components/Started';
import Listen from '@/components/Listen';
import DjSignup from '@/components/DjSignup';
import EventSection from '@/components/EventSection';
import AboutBento from '@/components/AboutBento';
import Footer from '@/components/Footer';

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute('href');
      e.preventDefault();
      if (href === '#') {
        lenis.scrollTo(0);
        return;
      }
      const el = document.querySelector(href);
      if (el) lenis.scrollTo(el, { offset: -88 });
    };
    document.addEventListener('click', onClick);

    return () => {
      document.removeEventListener('click', onClick);
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-plum font-body text-ivory">
        <div className="grain" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Viral />
          <CarPool />
          <GuestList />
          <WhosNext />
          <Started />
          <Listen />
          <DjSignup />
          <EventSection />
          <AboutBento />
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
}
